import React from 'react';
import { Department } from '@moxie/shared';

const DepartmentList: React.FC = () => {
  return <Department />;
};

export { DepartmentList };
